import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Button, message, Modal, Row, Skeleton, Space } from 'antd';
import { useEffect } from 'react';
import { ChargeType, FareType } from '../../../../../typesFinancial';
import { usePatchFareMutation } from '../../../../../services/fareApi';

type FareToArchiveModalProps = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  selectedFare: FareType;
  selectedCharge: ChargeType;
};

export function FareToArchiveModal(props: FareToArchiveModalProps) {
  const { showModal, setShowModal, selectedFare, selectedCharge } = props;

  function closeModal() {
    setShowModal(false);
  }

  const [
    patchFare,
    { isSuccess: isSuccessPatchFare, isLoading: isLoadingPatchFare },
  ] = usePatchFareMutation();

  useEffect(() => {
    if (isSuccessPatchFare) message.success('Tarifa arquivada com sucesso');
    closeModal();
  }, [isSuccessPatchFare]);

  async function handleFareToArchive() {
    if (
      selectedFare &&
      selectedFare.id &&
      selectedCharge &&
      selectedCharge.id
    ) {
      patchFare({
        action: 'archive_statement',
        id: selectedFare.id,
        chargeId: selectedCharge.id,
      });
    }
  }

  return (
    <Modal
      visible={showModal}
      title={<>Confirmar arquivamento de tarifa</>}
      className="TOSPrimaryModal"
      onCancel={closeModal}
      width={620}
      footer={null}
    >
      <>
        <h2>
          Essa tarifa será arquivada e não será possível faturar. Deseja
          continuar?
        </h2>
        <Row justify="end">
          <Space size={12}>
            <Button onClick={() => closeModal()} disabled={isLoadingPatchFare}>
              Cancelar
            </Button>
            <Button
              type="primary"
              danger
              onClick={() => handleFareToArchive()}
              loading={isLoadingPatchFare}
            >
              Sim, Arquivar
            </Button>
          </Space>
        </Row>
      </>
    </Modal>
  );
}
